import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MobilityCoachStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.neutral.main,
  height: 'calc(100vh - 30px)',
  padding: theme.spacing(5, 1, 4, 4),
  borderRadius: theme.spacing(4),
}));

export const ContentWrapperStyled = styled(Stack)(({ theme }) => ({
  overflowY: 'auto',
  paddingRight: theme.spacing(3),
}));

export const BadgeStyled = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  alignItems: 'center',
  padding: '6px 12px',
  backgroundColor: theme.palette.primary[100],
  color: theme.palette.primary.main,
  borderRadius: theme.spacing(2),
  fontSize: '0.75rem',
  fontWeight: 700,
  textTransform: 'uppercase',
}));

export const TitleStyled = styled(Typography)({
  fontSize: '5rem',
  fontWeight: 700,
  lineHeight: '5.125rem',
  color: '#0F172B',
});

export const SubtitleStyled = styled(Typography)({
  fontSize: '1.125rem',
  lineHeight: '2.25rem',
  color: '#45556C',
});

export const ButtonGroupStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2.5),
  '& .MuiButtonBase-root': {
    borderRadius: theme.spacing(4),
    minWidth: 'unset',
    width: 'unset',
    fontWeight: 700,
  },
}));

export const ButtonGroupButtonStyled = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(4),
  minWidth: 'unset',
  width: 'unset',
  fontWeight: 700,
}));

export const SectionTitleStyled = styled(Typography)({
  color: '#000532',
});

export const PrimaryCardStyled = styled(Card)(({ theme }) => ({
  background: 'linear-gradient(135deg, #155DFC 0%, #432DD7 100%)',
  borderRadius: theme.spacing(4),
  padding: theme.spacing(2.5, 3, 4, 3),
  color: '#fff',
  position: 'relative',
  overflow: 'visible',
  border: 'none',
  boxShadow: '0 4px 20px rgba(67, 83, 255, 0.3)',
}));

export const PrimaryCardTitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  lineHeight: '2rem',
  color: theme.palette.neutral.main,
}));

export const PrimaryCardTextStyled = styled(Typography)({
  fontSize: '1.125rem',
  lineHeight: '1.75rem',
  color: '#DBEAFE',
  width: '50%',
});

export const IconCardStyled = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  borderRadius: theme.spacing(4),
  padding: theme.spacing(2.5, 5, 5, 5),
  border: `1px solid ${theme.palette.primary[100]}`,
  backgroundColor: theme.palette.neutral.main,
  boxShadow: 'none',
}));

export const IconWrapperStyled = styled(Box)(({ theme }) => ({
  width: theme.spacing(9),
  height: theme.spacing(9),
  borderRadius: '50%',
  backgroundColor: theme.palette.primary[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
}));

export const CardTitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 700,
  lineHeight: '1.5rem',
  color: theme.palette.text.primary,
}));

export const CardTextStyled = styled(Typography)({
  fontSize: '1.125rem',
  lineHeight: '2rem',
  color: '#45556C',
});

export const DarkCardStyled = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  position: 'relative',
  overflow: 'visible',
  backgroundColor: '#000532',
  borderRadius: theme.spacing(4),
  padding: theme.spacing(3.5, 5, 5, 5),
  color: '#fff',
  border: 'none',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
}));

export const DarkCardTitleStyled = styled(Typography)({
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: '1.75rem',
  color: '#fff',
});

export const DarkCardTextStyled = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  lineHeight: '2rem',
  color: theme.palette.primary[100],
  width: '65%',
}));

export const RocketImageStyled = styled('img')({
  position: 'absolute',
  right: '97px',
  top: 0,
  transform: 'translateY(-50%)',
  objectFit: 'contain',
});

export const CheckIconStyled = styled(Box)({
  position: 'absolute',
  right: '32px',
  bottom: '32px',
  width: '64px',
  height: '64px',
});

export const NetworkStyled = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2),
  borderRadius: theme.spacing(4),
  backgroundColor: '#F5F6FF',
  padding: theme.spacing(2.5, 5, 5, 5),
}));

export const RectangleImageStyled = styled('img')({
  position: 'absolute',
  right: '97px',
  top: '20px',
  transform: 'translateY(-50%)',
  objectFit: 'contain',
});

export const ButtonDarkStyled = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  width: 'unset',
  minWidth: 'unset',
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  fontWeight: 700,
}));
